import { BaseSerializer } from "./baseSerializer.ts";
import {Notebook} from "@models/notebook.model.ts";


export class NotebookSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const notebook = new Notebook();
        this._copyAttributes(notebook, data);
        return notebook;

    }

}
